import React from 'react';
import { connect } from "react-redux";
import { API_URI, API_EXCEL_SUMMARY }  from './../consts'
import { ModalGeneratePayroll} from './Modals.jsx';
import ButtonModal  from './ButtonModal.jsx';

const ButtonsGroup = (props) => (
    <div className="btn-group pull-right">
        <ButtonModal
            getPartners={props.getPartners}
            btnClassName="btn btn-xs btn-warning"
            glyphiconBtn="glyphicon glyphicon-floppy-saved"
            btnText="Generar Nómina"
            isEnabled={props.recruiterId !== 0 && props.pendingPayroll && props.total !== 0 && props.notInPayroll}
        >
            <ModalGeneratePayroll
                pendingApproval={props.pendingApproval}
                generatePayroll={props.generatePayroll}
            />
        </ButtonModal>
        <a className="btn btn-xs btn-success" href={`${API_URI}excel-fee-ticket?initDate=${props.selectedStartDate.format('YYYY-MM-DD')}&finishDate=${props.selectedFinalDate.format('YYYY-MM-DD')}&recruiterId=${props.recruiterId}&inPayroll=1`}>
            <span className="glyphicon glyphicon-export"></span> Resumen Boletas
        </a>
        <a className="btn btn-xs btn-info" href={`/api/tesoreria/operadores?fechaInicio=${props.selectedStartDate.format('YYYY-MM-DD')}&fechaFin=${props.selectedFinalDate.format('YYYY-MM-DD')}`}>
            <span className="glyphicon glyphicon-export"></span> Operadores
        </a>
    </div>
);

const mapStateToProps = (state) => {
    return {
        selectedStartDate: state.dateState.selectedStartDate,
        selectedFinalDate: state.dateState.selectedFinalDate,
        recruiterId: state.partnerState.recruiterId
    };
};

export default connect(mapStateToProps, null)(ButtonsGroup);


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/ButtonsGroup.jsx